import { colors, fonts, screen } from 'components/styles/variables';
import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles({
  writeReviewButton: {
    '&.MuiButton-root': {
      backgroundColor: colors.ALB2,
    },
    '&.MuiButton-text': {
      color: colors.WHITE,
    },
    '&:hover': {
      backgroundColor: colors.ALB1,
    },
    '&:disabled': {
      opacity: 0.5,
    },
    '&.MuiButton-root:hover.Mui-disabled': {
      backgroundColor: colors.ALB2,
    },
    fontFamily: fonts.default,
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.2px',
    textTransform: 'none',
    width: '140px',
    padding: '8px',
    borderRadius: '8px',
    marginTop: '44px',
  },
  noReviewsContainer: {
    borderRadius: '8px',
    border: `1px solid ${colors.G2}`,
    padding: '72px 24px',
    margin: '24px 0',
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    [`@media screen and (max-width: 849px)`]: {
      margin: '24px 10px',
    },
  },
  noReviewsHeader: {
    fontSize: '18px',
    fontWeight: 700,
    lineHeight: '22px',
    letterSpacing: '0.2px',
    textAlign: 'center',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  sectionHeader: {
    fontWeight: 700,
    fontSize: '20px',
    lineHeight: '26px',
    letterSpacing: '0.2px',
    textTransform: 'uppercase',
    color: `${colors.BLACK}`,
    marginTop: '24px',
    [`@media screen and (max-width: ${screen.mdMax})`]: {
      padding: '0 24px 0 24px',
    },
    [`@media screen and (min-width: ${screen.smMin}) and (max-width: ${screen.mdMax})`]: {
      paddingLeft: '24px',
    },
  },
});
